/**
*
* SelectDropDownItem
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import ToolIcon from 'components/Icons/ToolIcon';

import SelectDropDownItemWrapper from './styles/SelectDropDownItemWrapper';


class SelectDropDownItem extends React.PureComponent {

  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {

    const {
      value,
      onChange,
      updateType,
      omitLowerCase,
    } = this.props;

    const thisValue = typeof value !== 'string' || omitLowerCase ? value : value.toLowerCase();
    const payload = this.props.updateType ? { value: thisValue, updateType: updateType } : thisValue;
    if (onChange) onChange(payload);
  }

  render() {

    const {
      titleAsFont,
      thisStyles,
      icon,
      iconSize,
      iconThisStyles,
      title,
      dropdownBackgroundColor,
      dropdownHoverBackgroundColor
    } = this.props;


    return (
      <SelectDropDownItemWrapper
        onClick={this.handleChange}
        thisStyles={thisStyles}
        titleAsFont={titleAsFont}
        dropdownBackgroundColor={dropdownBackgroundColor}
        dropdownHoverBackgroundColor={dropdownHoverBackgroundColor}
      >
        {title}
        {icon ? (
          <ToolIcon
            icon={icon}
            iconSize={iconSize}
            thisStyles={iconThisStyles}
          />
        ) : ''}
      </SelectDropDownItemWrapper>
    );

  }
}

SelectDropDownItem.propTypes = {
  onChange: PropTypes.func,
  titleAsFont: PropTypes.string,
  thisStyles: PropTypes.object,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  iconThisStyles: PropTypes.object,
  title: PropTypes.string,
  omitLowerCase: PropTypes.bool,
  updateType: PropTypes.string,
};

export default SelectDropDownItem;
